import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { authGuard } from './core/guards/auth.guard';

/**
 * The public booking page, behind four aliases that differ only in the mode `setPageMode()` reads
 * off the URL.
 *
 * Loaded lazily, like every other route here. Naming the class in `component:` pulled the whole
 * screen — Syncfusion's Schedule, moment and the EOI booking services — into the initial bundle
 * for every route in the app, including the public EOI journey, which shares none of it.
 */
const bookSlotComponent = () =>
  import('./features/scheduler/appointments/book-slot/book-slot.component').then(
    (m) => m.BookSlotComponent
  );

const routes: Routes = [
  {
    path: '',
    canActivate: [authGuard],
    loadChildren: () =>
      import('./features/side-menu/side-menu.module').then(
        (m) => m.SideMenuModule
      ),
  },
  {
    path: 'auth',
    canActivate: [authGuard],
    loadChildren: () =>
      import('./features/auth/auth.module').then((m) => m.AuthModule),
  },
  { path: 'scheduler/BookSlot', loadComponent: bookSlotComponent },
  { path: 'scheduler/EditBookingSlot', loadComponent: bookSlotComponent },
  { path: 'scheduler/RescheduleBookingSlot', loadComponent: bookSlotComponent },
  { path: 'scheduler/CancelBookingSlot', loadComponent: bookSlotComponent },
  {
    path: 'appointments',
    loadComponent: () =>
      import('./features/scheduler/appointments/select-schedule/select-schedule.component').then(
        (m) => m.SelectScheduleComponent
      ),
  },
  // Personal booking pages (COL-862): public, the link's token is the key.
  {
    path: 'book/:token',
    loadComponent: () => import('./features/meet/book-page.component').then((m) => m.BookPageComponent),
  },
  {
    path: 'eoi/register',
    loadChildren: () => import('./features/eoi/eoi.routes').then((m) => m.EOI_PUBLIC_ROUTES),
  },
  {
    path: '**',
    redirectTo: 'auth',
    pathMatch: 'full',
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
